/** word_match_type（ZENRIN Maps API 地番・住所検索で利用） */
export const ZENRIN_WORD_MATCH_TYPE = {
  /** 完全一致 */
  EXACT: 1,
  /** 前方一致 */
  PREFIX: 2,
  /** 部分一致 */
  PARTIAL: 3,
} as const;

export type ZenrinWordMatchType =
  (typeof ZENRIN_WORD_MATCH_TYPE)[keyof typeof ZENRIN_WORD_MATCH_TYPE];
